import { observer } from 'mobx-react';
import getMappingToolStore from '../data/MappingToolStore';
import MappingUtils, { getMappingStore } from '../utils/MappingUtils';
import { logDebug } from '../../../../shared/common/logger';
import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';

const MappingTicSheetTable: React.FC<{ overrideRenderingProps?: any }> = observer(({ overrideRenderingProps }) => {
	const mappingToolStore = getMappingToolStore();
	const dbMappings = mappingToolStore.dbMappings;
	const navigate = useNavigate();
	const mappingStore = getMappingStore();
	const [retries, setRetries] = useState(0);
	useEffect(() => {
		if (retries > 5) {
			navigate('/mapping');
			return;
		}
		// logDebug('retries', retries);
		const arr = location.href.split('?tuple=');
		let tupleID = '';
		let tupleAndStep: string[] = [];
		if (arr.length > 1) {
			tupleAndStep = JSON.parse(decodeURIComponent(arr[1]));
			if (tupleAndStep.length === 4) {
				tupleID = tupleAndStep[3];
			}
		} else {
			return;
		}


		// logDebug('tupleAndStep', tupleID, mappingToolStore.dbMappings.find((dbMapping) => dbMapping.tupleID === tupleID));
		if (tupleID && mappingToolStore.dbMappings.find((dbMapping) => dbMapping.tupleID === tupleID)) {
			if (!mappingToolStore.wizardStep && mappingStore.templateData && mappingToolStore.dbMappings) {
				mappingToolStore.selectedTuple = [parseInt(`${tupleAndStep[0]}`), parseInt(`${tupleAndStep[1]}`)];
				mappingToolStore.wizardStep = parseInt(`${tupleAndStep[2]}`);
			}
		} else {
			setTimeout(() => {
				setRetries(retries + 1);
			}, 2000);
		}
	}, [mappingStore.templateData, mappingToolStore.dbMappings, retries]);



	return <div className='flex flex-col'>
		<table className='bordered-table' >
			{
				MappingUtils.instance().getTableFromTemplate(
					(tuple) => {
						mappingToolStore.selectedTuple = tuple;
						mappingToolStore.wizardStep = 1;
					},
					(tuple) => {
						mappingToolStore.overTuple = tuple

					},
					mappingToolStore.selectedTuple,
					mappingToolStore.overTuple,
					{
						height: '60px'
					},
					undefined,
					dbMappings,
					overrideRenderingProps ? overrideRenderingProps : {
						showHeatmapData: true,
						showSelectables: true,
						showHasMapping: true,
					}
				).map((content, i) => <tbody key={i}>{content}</tbody>)
			}
		</table>
	</div>
});

export default MappingTicSheetTable;